/* esm.sh - applesauce-common@5.2.0/dist/operations/note */
export * from "/*applesauce-common@5.2.0/esnext/dist/operations/note.mjs";
